<script>
export default {
    name: 'vqAccordion',
    props: {
        open: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            innerOpen: this.open,
        };
    },
    computed: {
        openClass() {
            return {
                'tw-is-open tw-is-active': this.innerOpen 
            }
        }
    },
    methods: {
        toggle() {
            this.innerOpen = !this.innerOpen;
        },
        startTransition(el) {
            el.style.height = el.scrollHeight + "px";
        },
        endTransition(el) {
            el.style.height = "";
        },
    },
    watch: {
        open(value) {
            this.innerOpen = value;
        },
    },
    render(h) {
        return this.$scopedSlots.default({
        innerOpen: this.innerOpen,
        toggle : this.toggle,
        startTransition: this.startTransition,
        endTransition: this.endTransition,
        openClass: this.openClass
        });
    },
};
</script>